import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  FolderKanban,
  Landmark,
  LineChart,
  ShoppingCart,
  ShoppingBag,
  Timer,
  LogOut,
  Building2,
  Network,
  TrendingUp,
} from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { cn } from "../lib/utils";

const primary = [
  { to: "/app/empresas", label: "Resumen empresas", icon: Building2, testId: "nav-empresas" },
  { to: "/app/pnl-analitico", label: "P&G Analítico", icon: Network, testId: "nav-pnl-analitico" },
  { to: "/app/rentabilidad", label: "Rentabilidad proyectos", icon: TrendingUp, testId: "nav-rentabilidad" },
];

const secondary = [
  { to: "/app/overview", label: "Visión global", icon: LayoutDashboard, testId: "nav-overview" },
  { to: "/app/projects", label: "Proyectos", icon: FolderKanban, testId: "nav-projects" },
  { to: "/app/accounting", label: "Contabilidad", icon: Landmark, testId: "nav-accounting" },
  { to: "/app/analytic", label: "Analítica", icon: LineChart, testId: "nav-analytic" },
  { to: "/app/purchases", label: "Compras", icon: ShoppingBag, testId: "nav-purchases" },
  { to: "/app/sales", label: "Ventas", icon: ShoppingCart, testId: "nav-sales" },
  { to: "/app/timesheets", label: "Partes de horas", icon: Timer, testId: "nav-timesheets" },
];

const NavItem = ({ to, label, icon: Icon, testId }) => (
  <NavLink
    to={to}
    data-testid={testId}
    className={({ isActive }) =>
      cn(
        "flex items-center gap-3 px-5 py-2 text-sm text-slate-700 hover:bg-slate-50 transition-colors duration-150 border-l-2",
        isActive
          ? "bg-slate-50 border-l-[#002FA7] text-slate-900 font-medium"
          : "border-l-transparent"
      )
    }
  >
    <Icon className="w-4 h-4" />
    <span className="truncate">{label}</span>
  </NavLink>
);

export const Sidebar = () => {
  const { user, logout } = useAuth();
  return (
    <aside
      className="w-60 shrink-0 bg-white border-r border-slate-200 flex flex-col"
      data-testid="sidebar"
    >
      <div className="p-5 border-b border-slate-200">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded bg-[#002FA7] flex items-center justify-center text-white font-semibold text-sm">
            BI
          </div>
          <div>
            <div className="font-semibold text-slate-900 tracking-tight text-sm">Odoo BI</div>
            <div className="text-[11px] text-slate-500">Cuadro de mando</div>
          </div>
        </div>
      </div>

      <nav className="flex-1 py-3 overflow-y-auto" data-testid="sidebar-nav">
        <div className="px-5 py-1 text-[10px] uppercase tracking-[0.08em] font-semibold text-slate-400">
          Vistas ejecutivas
        </div>
        {primary.map((it) => (
          <NavItem key={it.to} {...it} />
        ))}
        <div className="px-5 mt-4 py-1 text-[10px] uppercase tracking-[0.08em] font-semibold text-slate-400">
          Detalle por módulo
        </div>
        {secondary.map((it) => (
          <NavItem key={it.to} {...it} />
        ))}
      </nav>

      <div className="border-t border-slate-200 p-4" data-testid="sidebar-user">
        {user && (
          <>
            <div className="text-xs text-slate-500 mb-1">Conectado como</div>
            <div className="text-sm font-medium text-slate-900 truncate">{user.name}</div>
            <div className="text-xs text-slate-500 truncate flex items-center gap-1 mt-1">
              <Building2 className="w-3 h-3" />
              <span className="truncate">{user.company}</span>
            </div>
            <button
              onClick={logout}
              data-testid="logout-button"
              className="mt-3 w-full flex items-center justify-center gap-2 text-xs font-medium text-slate-700 hover:text-[#002FA7] hover:bg-slate-50 border border-slate-200 rounded py-1.5 transition-colors duration-150"
            >
              <LogOut className="w-3.5 h-3.5" />
              Cerrar sesión
            </button>
          </>
        )}
      </div>
    </aside>
  );
};
